// extracted by mini-css-extract-plugin
export var card = "_44-0";
export var content = "_44-1";
export var contentLoading = "_44-2";